<div class="cg-wrap">

  <!-- ── Encabezado ────────────────────────────────────────────────────── -->
  <div class="cg-header">
    <div class="cg-header__left">
      <span class="cg-header__icon"><i class="pi pi-chart-bar"></i></span>
      <div>
        <h2 class="cg-header__title">Galería de Gráficas</h2>
        <p class="cg-header__sub">Explora todos los tipos disponibles · datos de demostración</p>
      </div>
    </div>
    <div class="cg-header__chips">
      <span class="cg-chip cg-chip--ec">ECharts · 8</span>
      <span class="cg-chip cg-chip--cj">Chart.js · 12</span>
    </div>
  </div>

  <!-- ── Tabs ──────────────────────────────────────────────────────────── -->
  <mat-tab-group class="cg-tabs" animationDuration="200ms" [disableRipple]="true">

    <!-- ══════════════════════════════════════
         Tab 1 — ECharts
    ══════════════════════════════════════ -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="cg-tab-label cg-tab-label--ec">
          <i class="pi pi-chart-pie"></i>
          ECharts
        </span>
      </ng-template>

      <div class="cg-lib-note cg-lib-note--ec">
        <i class="pi pi-info-circle"></i>
        <strong>ECharts</strong> — Potente y altamente personalizable. Rose/Nightingale y Funnel son distintivos.
        Mejor rendimiento con datasets grandes. Buena integración con Angular.
      </div>

      <div class="cg-grid">
        @for (card of echartCards; track card.title; let i = $index) {
          <div class="cg-cell" [class.cg-cell--wide]="card.chartType === 'ec_bar'">
            <div class="cg-cell__badge cg-cell__badge--ec">{{ i + 1 }}</div>
            <app-echart-card [config]="card" />
          </div>
        }
      </div>
    </mat-tab>

    <!-- ══════════════════════════════════════
         Tab 3 — Chart.js
    ══════════════════════════════════════ -->
    <mat-tab>
      <ng-template mat-tab-label>
        <span class="cg-tab-label cg-tab-label--cj">
          <i class="pi pi-objects-column"></i>
          Chart.js
        </span>
      </ng-template>

      <div class="cg-lib-note cg-lib-note--cj">
        <i class="pi pi-info-circle"></i>
        <strong>Chart.js</strong> — Liviano y versátil. 12 tipos nativos incluyendo Bubble y Polar Area.
        Render perezoso activado: las gráficas se construyen al entrar al viewport.
      </div>

      <div class="cg-grid">
        @for (card of cjCards; track card.title; let i = $index) {
          <div class="cg-cell" [class.cg-cell--wide]="card.chartType === 'cj_combo' || card.chartType === 'cj_bar_h' || card.chartType === 'cj_area'">
            <div class="cg-cell__badge cg-cell__badge--cj">{{ i + 1 }}</div>
            <app-chartjs-card [config]="card" />
          </div>
        }
      </div>
    </mat-tab>

  </mat-tab-group>

</div>
